<template>
  <div class="body-main">
    <div class="banner-container">
      <div class="wrap">
        <a style="display: none">
          <div class="logo-class"></div>
          <span class="top-desc">系统培养人才</span>
        </a>
        <h2>跨境电商实训平台</h2>
        <div class="desc">
          精选跨境电商平台，全面一体化练习。大数据选品、电商平台、广告引流、直播推广。
        </div>
      </div>
    </div>
    <div class="training-container">
      <div class="wrap">
        <!-- <div class="type-row">
          <div class="all-course-num">共7个仿真操作系统</div>
        </div> -->
        <div v-if="trainingData.length > 0" class="course-row">
          <div v-for="traing in trainingData" :key="traing.name" class="card">
            <a>
              <div
                class="img-con"
                :style="{
                  'background-image': `url(${traing.imageUrl})`,
                  'border-bottom': '1px dashed #e4e4e4',
                }"
              ></div>
            </a>
            <div class="text-con">
              <a class="title"> {{ traing.name }} </a>
            </div>
            <div class="bottom-buy">
              <div v-if="!traing.cardId" class="go-btn r" @click="buyGoods(traing)">购买</div>
              <!-- <div class="go-btn r" @click="toTraining(traing)">开始实训</div> -->
              <template v-else>
                <div class="go-btn r" @click="toTrainingURL(traing.trainingUrl)">开始实训</div>
                <div class="go-btn l" style="background-color: #f0f8ff;" @click="resetTraining(traing)">重置实训</div>
              </template> 
            </div>
          </div>
        </div>
        <el-empty
          v-else
          description="单位未开通实训平台"
          :image-size="200"
        ></el-empty>
      </div>
    </div>

    <!-- 设置选择班级对话框 -->
    <el-dialog
      title="选择班级"
      :visible.sync="dialogClassesFormVisible"
      :close-on-click-modal="false"
      width="20%"
      class="classes-dialog"
    >
      <div>
        <i class="el-icon-warning-outline"></i>
        <span>存在多个班级开通了实训，请选择需进入的班级</span>
      </div>

      <div class="classes-row">
        <el-card
          v-for="classes in classesData"
          :key="classes.id"
          shadow="hover"
          class="box-card classes-card"
        >
          <el-link
            :underline="false"
            @click="handleSelectClasses(classes.id)"
            >{{ classes.name }}</el-link
          >
        </el-card>
      </div>
    </el-dialog>
    <!-- <el-dialog
      title="选择班级"
      :visible.sync="dialogClassesFormVisible"
      :close-on-click-modal="false"
      width="20%"
    >
      <el-row>
        <el-col :span="24" style="padding-bottom: 10px;">
          <i class="el-icon-warning-outline"></i>
          <span>存在多个班级开通了实训，请选择需进入的班级</span>
        </el-col>
      </el-row>
      <el-row type="flex" justify="center">
        <el-col :span="12" :offset="0">
          <el-card class="box-card" style="text-align: center">
            铁路1班
          </el-card>
        </el-col>
        <el-col :span="12" :offset="2">
          <el-card class="box-card" style="text-align: center">
            市场营销102
          </el-card>
        </el-col>
        <el-col :span="12" :offset="2">
          <el-card class="box-card" style="text-align: center">
            市场营销102
          </el-card>
        </el-col>
      </el-row>
    </el-dialog> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// import { companysService } from "@/api/companys";
import { classesService } from "@/api/classes";
import { usersService } from "@/api/users";
import { amazonService } from "@/api/amazon";
import { aliexpressService } from "@/api/aliexpress";
import { selectGoodsService } from "@/api/select-goods"; 
import { googleService } from "@/api/google"; 
import { facebookService } from "@/api/facebook";
import config from "@/utils/config";
import { learningCardService } from '@/api/learningCards'

export default {
  name: "Training",
  data() {
    return {
      trainingData: [],

      dialogClassesFormVisible: false,
      classesData: [],
      // 选中的实训
      selectTraining: undefined,
    };
  },
  computed: {
    ...mapGetters("oidc", ["oidcIsAuthenticated", "oidcUser"]),
    hasAccess: function () {
      return this.oidcIsAuthenticated || this.$route.meta.isPublic;
    },
    getOidcUser: function () {
      return this.oidcUser;
    },
  },
  created() {
    this.fetchConfig();
  },
  methods: {
    toTrainingURL(url) {
      // this.dialogClassesFormVisible = true;

      window.open(url, "_blank");
    },
    async fetchConfig() {
      // await config.getTrainingData.then((training) => {
      //   // console.log(training);
      //   // this.trainingData = [];

      //   this.trainingData = training.map((d) => {
      //     return {
      //       id: d.id,
      //       imageUrl: require(`@/${d.imageUrl}`),
      //       name: d.name,
      //       trainingUrl: d.trainingUrl,
      //     };
      //   });

      //   // //const user = this.$store.getters["oidc/oidcUser"];
      //   // const companyId = this.oidcUser?.company_id;

      //   // companysService.getCompanysById(companyId).then((res) => {
      //   //   const trainingAuthorized = res.trainingAuthorized;
      //   //   training.forEach((item) => {
      //   //     if (trainingAuthorized.includes(item.id)) {
      //   //       this.trainingData.push({
      //   //         id: item.id,
      //   //         imageUrl: require(`@/${item.imageUrl}`),
      //   //         name: item.name,
      //   //         trainingUrl: item.trainingUrl,
      //   //       });
      //   //     }
      //   //   });
      //   // });
      // });
      Promise.all([
        await config.getTrainingData,
        learningCardService.getAvailableLearningCards()
      ]).then((result) => {
        var training = result[0]
        var cards = result[1].items     

        this.trainingData = training.map((d) => {
          return {
            id: d.id,
            cardId: cards.find(c => c.platform === d.id)?.id,
            imageUrl: require(`@/${d.imageUrl}`),
            name: d.name,
            trainingUrl: d.trainingUrl,
          };
        });
      });

    },
    buyGoods(traing) {
      this.$router.push(`/goods/${traing.id}`);
    },
    toTraining(traing) {
      console.log(traing);
      this.selectTraining = traing;
      if (traing.id === "1") {
        amazonService.getCurrentUserTrainings().then(res => {
          if (res.length > 1) {
            this.classesData = res.map((item) => {
              return {
                id: item.classesId,
                name: item.ptName,
              };
            });
            // 班级选择弹层
            this.dialogClassesFormVisible = true;
          } else if (res.length === 0) {
            this.$message("请先开启实训");
          } else {
            const classesId = res[0].classesId;
            this.handleSelectClasses(classesId);
          }
        });
      } else if (traing.id === "2") {
        aliexpressService.getCurrentUserTrainings().then(res => {
          if (res.length > 1) {
            this.classesData = res.map((item) => {
              return {
                id: item.classesId,
                name: item.name,
              };
            });
            // 班级选择弹层
            this.dialogClassesFormVisible = true;
          } else if (res.length === 0) {
            this.$message("请先开启实训");
          } else {
            const classesId = res[0].classesId;
            this.handleSelectClasses(classesId);
          }
        });
      } else if (traing.id === "3") {
        classesService.getClassesAndTrainingPlan(traing.id).then((res) => {
          if (res.length > 1) {
            this.classesData = res;
            // 班级选择弹层
            this.dialogClassesFormVisible = true;
          } else if (res.length === 0) {
            this.$message("请先开启实训");
          } else {
            const classesId = res[0].id;
            this.handleSelectClasses(classesId);
            //window.open(traing.trainingUrl, "_blank");
          }
        });
      } else if (traing.id === "5") {
        facebookService.getCurrentUserTrainings().then((res) => {
          if (res.length > 1) {
            this.classesData = res.map((item) => {
              return {
                id: item.classId,
                name: item.name,
              };
            });
            // 班级选择弹层
            this.dialogClassesFormVisible = true;
          } else if (res.length === 0) {
            this.$message("请先开启实训");
          } else {
            const classesId = res[0].classId;
            this.handleSelectClasses(classesId);
            //window.open(traing.trainingUrl, "_blank");
          }
        });
      } else {
        window.open(traing.trainingUrl, "_blank");
      }
    },
    // 重置实训
    resetTraining(traing) {
      
      this.$prompt('此操作将重置该实训的全部数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error',
        showInput: true,
        inputPlaceholder: `RESET`,
        inputPattern: /^RESET$/,
        inputErrorMessage: '请输入"RESET"以确认重置',
      })
      .then(() => {
        // 按钮状态
        console.log(traing);
          
        if (traing.id === "1") {
          amazonService.resetCurrentUserTraining().then((res) => {
            if (res) {
              this.$message({
                type: "success",
                message: "重置成功"
              });
            } else {
              this.$message("重置失败，请稍后再试");
            }
          });
        } else if (traing.id === "2") {
          aliexpressService.resetCurrentUserTraining().then((res) => {
            if (res) {
              this.$message({
                type: "success",
                message: "重置成功"
              });
            } else {
              this.$message("重置失败，请稍后再试");
            }
          });
        } else if (traing.id === "3") {
          selectGoodsService.resetCurrentUserTraining().then((res) => {
            if (res) {
              this.$message({
                type: "success",
                message: "重置成功"
              });
            } else {
              this.$message("重置失败，请稍后再试");
            }
          });
        } else if (traing.id === "4") {
          googleService.resetCurrentUser().then((res) => {
            if (res) {
              this.$message({
                type: "success",
                message: "重置成功"
              });
            } else {
              this.$message("重置失败，请稍后再试");
            }
          });
        } else if (traing.id === "5") {
          facebookService.resetCurrentUser().then((res) => {
            if (res) {
              this.$message({
                type: "success",
                message: "重置成功"
              });
            } else {
              this.$message("重置失败，请稍后再试");
            }
          });
        } else {
          this.$message("该实训暂不支持重置");
        }
      })  
    },
    // 选择某班级并跳转
    handleSelectClasses(classesId) {
      usersService.setCurrentClassesId(classesId).then((res) => {
        if (res.data) {
          this.dialogClassesFormVisible = false;
          window.open(this.selectTraining.trainingUrl, "_blank");
        }
      });
    }
  },
};
</script>

<style scoped>
.el-dialog__body {
  padding: 15px 20px 20px !important;
}

.body-main {
  min-height: 750px;
  position: relative;
}

.banner-container {
  height: 220px;
  width: 100%;
  /* background-image: url(https://class.imooc.com/static/module/marketpage2020/img/index/banner3.png?t=1?t=712);
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat; */
  text-align: center;
}

.banner-container .wrap {
  width: 1152px;
  margin: 0 auto;
  height: 100%;
  padding-top: 75px;
  box-sizing: border-box;
  position: relative;
}

.banner-container .wrap .logo-class {
  width: 126px;
  height: 46px;
  background-image: url(https://class.imooc.com/static/module/marketpage2020/img/index/logo-class.png?t=3?t=712);
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  position: absolute;
  left: 0;
  top: 24px;
}

.banner-container .wrap .top-desc {
  height: 12px;
  position: absolute;
  left: 134px;
  top: 46px;
  font-size: 12px;
  color: #545c63;
  letter-spacing: 1px;
  line-height: 12px;
}

.banner-container .wrap h2 {
  font-size: 60px;
  font-weight: 700;
  color: #545c63;
  letter-spacing: 4.69px;
  text-align: center;
  line-height: 60px;
  margin-bottom: 20px;
}

.banner-container .wrap .desc {
  display: inline-block;
  font-size: 19px;
  color: #545c63;
  text-align: center;
  line-height: 24px;
  font-weight: 300;
}

.training-container {
  width: 100%;
}

.wrap .type-row {
  height: 84px;
  width: 100%;
  padding-top: 30px;
  box-sizing: border-box;
}

.wrap .type-row .all-course-num {
  font-size: 12px;
  line-height: 30px;
  color: #9199a1;
  float: right;
}

.training-container .wrap {
  width: 1152px;
  height: 100%;
  margin: 0 auto;
}

.training-container .course-row {
  width: 100%;
  display: -webkit-box;
  display: -moz-box;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -moz-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  -o-flex-wrap: wrap;
  flex-wrap: wrap;

  padding-top: 30px;
}

.l {
  float: left;
}

.wrap .course-row .card {
  width: 348px;
  height: 286px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  margin-right: 53px;
  position: relative;
  margin-bottom: 34px;
}

.wrap .course-row .card:nth-child(3n) {
  margin-right: 0;
}

.wrap .course-row .card .img-con {
  width: 100%;
  height: 172px;
  position: relative;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}

.wrap .course-row .card .text-con {
  padding: 0 20px;
  padding-top: 16px;
  /* position: absolute; */
  /* bottom: 50px; */
  background: #fff;
  max-height: 88px;
}

.wrap .course-row .card .text-con .title {
  font-size: 16px;
  color: #1c1e20;
  /* color: #9199a1; */
  line-height: 22px;
  max-height: 44px;
  display: block;
  transition: all 0.3s;
  -moz-transition: all 0.3s;
  -webkit-transition: all 0.3s;
  -o-transition: all 0.3s;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;

  text-align: center;
}

.card .bottom-buy {
  position: absolute;
  bottom: 22px;
  left: 0;
  padding: 0 20px;
  height: 26px;
  width: 100%;
  box-sizing: border-box;
}

.r {
  float: right;
}

.card .bottom-buy .go-btn {
  border: 1px solid #dbdfe3;
  border-radius: 13px;
  width: 80px;
  text-align: center;
  line-height: 26px;
  box-sizing: border-box;
  font-size: 12px;
  color: #1c1e20;
  cursor: pointer;
  transition: all 0.3s;
  -moz-transition: all 0.3s;
  -webkit-transition: all 0.3s;
  -o-transition: all 0.3s;
}

/* .el-dialog {
  width: 50%;
} */

.classes-row {
}

.classes-row .classes-card {
  margin-top: 10px;
  text-align: center;
  /* cursor: pointer; */
}
</style>

<style>
.classes-dialog .el-dialog {
  width: 20% !important;
}

@media (max-width: 992px) {
  .classes-dialog .el-dialog {
    width: 40% !important;
  }
}

@media only screen and (max-width: 767px) {
  .classes-dialog .el-dialog {
    width: 60% !important;
  }
}
</style>
